import { Component, ChangeDetectionStrategy } from '@angular/core';
import { of, Observable } from 'rxjs';
import { UrlBuilder } from '../../../core';
import { NavigationServiceLink } from '../../../sample-tracking/service/navigation-service/navigation-service-link';

@Component({
    selector: 'sm-nav',
    template: require('./sm-navigation.component.html'),
    styles: [require('./sm-navigation.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SMNavigationComponent {

    public topLevelMenu: Observable<NavigationServiceLink[]>;

    private readonly registeredSamples = this.urlBuilder
        .esa()
        .sampleManagement().registeredSamples().url();

    private readonly pendingRegistration = this.urlBuilder
        .esa()
        .sampleManagement().pendingRegistration().url();

    private readonly samplesShippedByProtocol = this.urlBuilder
        .esa()
        .sampleManagement().siteShipping().samplesShipmentByProtocol().url();

    private readonly shipmentList = this.urlBuilder
        .esa()
        .sampleManagement().siteShipping().inProgressShipmentList().url();

    private readonly submittedShipmentList = this.urlBuilder
        .esa()
        .sampleManagement().siteShipping().submittedShipmentList().url();

    private readonly createShipment = this.urlBuilder
        .esa()
        .sampleManagement().siteShipping().createShipment().url();

    constructor(
        private urlBuilder: UrlBuilder) {

        this.topLevelMenu = of(this.getLinks());
    }

    private getLinks() {
        const links: NavigationServiceLink[] = [];
        links.push(new NavigationServiceLink('Registered Samples', of(this.registeredSamples), null, null, null, of(false), null, null, 'images/sample_tracking/barcode.svg', null, true));
        links.push(new NavigationServiceLink('Pending Registration', of(this.pendingRegistration), null, null, null, of(false), null, null, 'images/sample_tracking/pending-registration.svg', null, true));
        let shipmentsLink = new NavigationServiceLink('Shipments', of(this.shipmentList), 'local_shipping', null, null, of(false), null, null, null, null, true);
        let children: NavigationServiceLink[] = [];
        children.push(new NavigationServiceLink('In-Progress Shipments', of(this.shipmentList), 'list', null, null, of(false), null, null, null, null, true));
        children.push(new NavigationServiceLink('Submitted Shipments', of(this.submittedShipmentList), 'list', null, null, of(false), null, null, null, null, true));
        children.push(new NavigationServiceLink('Samples by Protocol', of(this.samplesShippedByProtocol), 'list', null, null, of(false), null, null, null, null, true));
        children.push(new NavigationServiceLink('Create a Shipment', of(this.createShipment), 'list', null, null, of(false), null, null, null, null, true));
        shipmentsLink.children = of(children);
        links.push(shipmentsLink);
        return links; 
    }
}